export const GUARD = {
  PROFILE_COMPLETE: 'profile_complete',
}
